
<div class="testimonial-bg">
    <div class="max-page-width">

        <div *ngIf="evaluationClientsLogsModel != null && evaluationClientsLogsModel.length > 0" class="testimonial-container">
            <h2 class="text-center mb-4">{{ 'WhatYourClientSayAboutYou' | translate }}</h2>
            <owl-carousel-o class="m-0 arabic-direction" [options]="customOptions" >
                <ng-template class="row" carouselSlide *ngFor="let testimonial of evaluationClientsLogsModel" >
                    <!-- <div class="testimonial-img">
                        <div class="client-img">
                            <img class="img-circle" [src]="testimonial.src" [alt]="testimonial.alt" [title]="testimonial.name">
                        </div>
                    </div>     -->
                
            
                    <div class="testimonial-box">
                        <div class="row">
                            <div class="col-md-4 col-12 client-img">
                            <img class="img-circle"
                            [src]="attachmentService.getImageLink(testimonial.evaluatorRefID,attachmentScopesEnum.Customer, attachmentTypeEnum.CustomerIndividualImage)"
                                [title]="testimonial.customerName">
                                <!-- [src]="testimonial.src"
                                [alt]="testimonial.alt" -->
                            </div>
                            <div class="col-md-8 col-12 pl-md-0">
                                <div class="testimonial-name">{{testimonial.customerName}}</div>
                                <div class="testimonial-client text-muted">{{testimonial.createdOn | date:'longDate'}} <!-- {{testimonial.createdOn | date:'shortTime'}} --></div>
                            </div>
                        </div>
                        <div>“{{testimonial.evaluatorComment}}”</div>
                    </div>
            
            
                </ng-template>      
            </owl-carousel-o>
        </div>
    </div>
</div>    